// extracted by mini-css-extract-plugin
module.exports = {"addRowButton":"styles_addRowButton__y6DwY","icon":"styles_icon__2_ZsU"};